export default "__VITE_ASSET__BktX5hoV__"